

const axios = require('axios');
export const AXIOS_API_INSTANCE = axios.create();
export const API_URL = "https://k3r57jx8fg.execute-api.us-east-2.amazonaws.com/main";
export const lightColor = 'rgba(255, 255, 255, 0.7)';
export const all_locations_object = {"id": "all", "name": "All Locations", "short_name": "All Locations", "label": "All Locations"}

export const LONG_DATE_FORMAT = 'ddd, D MMM YYYY h:mm A'
